import tw, { styled } from 'twin.macro';

const TableHead = styled.thead`
  ${tw`border-0 border-b border-solid border-gray-200`}
`;

export default TableHead;
